<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">设备名称：</div>
        <div class="fl">
          <a-input
            allowClear
            v-model:value="elementParams.name"
            placeholder="请输入设备名称"
            @pressEnter="getTableList"
          />
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">Distinct_Id：</div>
        <div class="fl">
          <a-input
            allowClear
            v-model:value="elementParams.distinctId"
            placeholder="请输入Distinct_Id"
            @pressEnter="getTableList"
          />
        </div>
      </div>
      <div class="oh fl  mr20">
        <div class="fl lh30">创建人：</div>
        <div class="fl">
          <a-select
            ref="select"
            allowClear
            style="width: 180px"
            v-model:value="elementParams.creater"
            placeholder="请输入创建人"
            @change="getTableList"
            show-search
            optionFilterProp="label"
            :options="userList"
          >
          </a-select>
        </div>
      </div>
    </div>
    <div class="fourElementsContainer right">
      <a-button type="primary" class="btn mr10" @click="getTableList"
        >查询</a-button
      >
      <a-button type="default" @click="resetFormData">重置</a-button>
      <a-button type="primary" class="btn" @click="createNewLayer"
        >新建白名单</a-button
      >
    </div>
  </div>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
import { user_list } from '@/server/modules/filter'

export default {
  setup() {
    const initData = inject('initState')
    let userList = ref([])
    async function getUserList() {
      const { success, data } = await user_list()
      if (success) {
        userList.value = data.map(item => ({
          label: item.name,
          value: item.name
        }))
      }
    }
    getUserList()

    return {
      userList,
      ...toRefs(initData)
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px;
  margin: 20px;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
.fourElementsContainer.right {
  justify-content: flex-end;
}

.btn {
  margin-left: 10px;
}
</style>
